export const PURGE = 'persist/PURGE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
